import dayjs from 'dayjs'
import { getAccessTokenExpiryReadable } from 'src/consumer/services/localstorageServices'

export default function TokenExpiryTimeForChamberRoom() {
  const tokenExpiryTime = getAccessTokenExpiryReadable()
  const expiryTime = dayjs(tokenExpiryTime).local()
  return (
    <div className="d-flex" style={{
      backgroundColor: 'rgba(255, 255, 255, 0.5)',
      padding: '10px 18px',
      borderRadius: '12px',
      backdropFilter: 'blur(15px)',
      border: '1px solid rgba(150, 150, 200, 0.2)'
    }}>
      <div
        style={{
          minWidth: '180px',
          textAlign: 'left',
          color: '#5a67d8',
          fontWeight: '600',
          fontSize: '14px'
        }}
      >
        Access Expires:{' '}
      </div>
      <div style={{ color: '#4a5568', fontWeight: '500', fontSize: '14px' }}>
        {expiryTime.format('DD MMMM YYYY h:mm A')}
      </div>
    </div>
  )
}
